import { Box, useMediaQuery, useTheme } from "@mui/material";
import { ArrowNarrowLeftIcon, Button, Typography } from "components";
import { Paths } from "configs";
import { gray } from "configs/colors";
import { useNavigate } from "react-router-dom";

import permission from "../../assets/images/permission.png";

export const NotAuthorized = () => {
  const navigate = useNavigate();

  return (
    <Box paddingY="84px" display="flex" height="100%">
      <Box
        paddingX="56px"
        gap="28px"
        display="flex"
        justifyContent="center"
        alignSelf="center"
        flex="1"
      >
        <Box display="flex">
          <Box alignItems="center" alignSelf="center" pr="32px">
            <Typography type="DisplayXL" color={gray[900]} fontWeight={600}>
              Permission denied!
            </Typography>
            <Typography type="TextXL" color={gray[600]} mt="24px" mb="48px">
              You do not have permission to access this page. Please contact
              Administrator for more info.
            </Typography>
            <Box>
              <Button
                startIcon={<ArrowNarrowLeftIcon />}
                variant="outlined"
                sx={{
                  mr: "12px",
                }}
                onClick={() => {
                  return navigate(-1);
                }}
              >
                Go back
              </Button>
              <Button
                onClick={() => {
                  return navigate(Paths.App);
                }}
              >
                Take me home
              </Button>
            </Box>
          </Box>
        </Box>
        <Box width="640px" height="100%">
          <Box
            component="img"
            src={permission}
            maxWidth="100%"
            maxHeight="100%"
          />
        </Box>
      </Box>
    </Box>
  );
};
